import React from 'react';
import { Assignment } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { useGetTicketsAssignedToQuery } from '../../../../services/TicketService';
import { countActiveTickets } from '../../utils';
import MetricCard from '../MetricCard';

/**
 * AssignedToMeCard - Displays count of tickets directly assigned to the current user
 * Excludes closed/cancelled tickets to show only actionable assignments
 */
function buildAssignedToMeUrl(name?: string | null, email?: string | null): string {
  const params = new URLSearchParams();
  if (name) params.set('assignedTo', name);
  if (email) params.set('email', email);
  return `/tickets/assigned-to-me?${params.toString()}`;
}

const AssignedToMeCard: React.FC = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  
  // Get tickets assigned to the user
  const { data: assignedTickets = [], isLoading: assignedTicketsLoading } = useGetTicketsAssignedToQuery(
    { userName: account?.name || '', email: account?.username || '' },
    { skip: !account?.name }
  );

  const assignedToMeCount = countActiveTickets(assignedTickets);

  const handleClick = () => {
    if (account?.name) navigate(buildAssignedToMeUrl(account.name, account.username));
    else navigate('/tickets/assigned-to-me');
  };

  return (
    <MetricCard
      title="Assigned to Me"
      value={assignedToMeCount}
      icon={Assignment}
      color="#f59e0b"
      loading={assignedTicketsLoading}
      onClick={handleClick}
      subtitle="Pending action"
    />
  );
};

export default AssignedToMeCard;